var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[(_vm.fact)?_c('p',[_vm._v(_vm._s(_vm.fact.customer_firstname))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }